import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { InitialData } from "../models/initialData.model";
import { Observable, of } from "rxjs";
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})
export class InitialService {

  private _initialAppData: Observable<InitialData> | null = null;
  constructor(private http: HttpClient) { }

  

  public getInitialData(): Observable<InitialData> {
    if (this._initialAppData)
      return this._initialAppData;

    this._initialAppData = this.http.get<InitialData>('/api/initialdata').pipe(shareReplay(1));
    return this._initialAppData;
  }
}
